import {
  mainRequests
} from './custom'
export default {
  createUser (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .post('/createUser', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  submitLoan (payload) {
    return new Promise(function (resolve, reject) {
      mainRequests
        .post('/saveData', payload)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
